/**
 * Newsletter Service
 * API-Calls für Newsletter-Verwaltung
 */

import api from './api';

// ============================================
// Dashboard & Stats
// ============================================

/**
 * Newsletter-Statistiken abrufen
 */
export async function getNewsletterStats(productId) {
  return api.get(`/newsletter/${productId}/stats`);
}

// ============================================
// Subscriber Management
// ============================================

/**
 * Subscriber-Liste abrufen
 */
export async function getSubscribers(productId, options = {}) {
  const params = new URLSearchParams();
  if (options.status) params.append('status', options.status);
  if (options.limit) params.append('limit', options.limit);
  if (options.offset) params.append('offset', options.offset);

  const queryString = params.toString();
  return api.get(`/newsletter/${productId}/subscribers${queryString ? `?${queryString}` : ''}`);
}

/**
 * Subscriber manuell hinzufügen
 */
export async function addSubscriber(productId, { email, name }) {
  return api.post(`/newsletter/${productId}/subscribers`, { email, name });
}

/**
 * Subscriber-Status ändern
 */
export async function updateSubscriber(subscriberId, status) {
  return api.patch(`/newsletter/subscribers/${subscriberId}`, { status });
}

/**
 * Subscriber löschen
 */
export async function deleteSubscriber(subscriberId) {
  return api.delete(`/newsletter/subscribers/${subscriberId}`);
}

// ============================================
// Issue Management (Ausgaben)
// ============================================

/**
 * Alle Ausgaben eines Newsletters abrufen
 */
export async function getIssues(productId, options = {}) {
  const params = new URLSearchParams();
  if (options.status) params.append('status', options.status);
  if (options.limit) params.append('limit', options.limit);
  if (options.offset) params.append('offset', options.offset);

  const queryString = params.toString();
  return api.get(`/newsletter/${productId}/issues${queryString ? `?${queryString}` : ''}`);
}

/**
 * Einzelne Ausgabe abrufen
 */
export async function getIssue(issueId) {
  return api.get(`/newsletter/issues/${issueId}`);
}

/**
 * Neue Ausgabe erstellen (Entwurf)
 */
export async function createIssue(productId, issueData) {
  return api.post(`/newsletter/${productId}/issues`, issueData);
}

/**
 * Ausgabe aktualisieren
 */
export async function updateIssue(issueId, issueData) {
  return api.patch(`/newsletter/issues/${issueId}`, issueData);
}

/**
 * Ausgabe löschen (nur Entwürfe)
 */
export async function deleteIssue(issueId) {
  return api.delete(`/newsletter/issues/${issueId}`);
}

// ============================================
// Versand
// ============================================

/**
 * Newsletter sofort senden
 */
export async function sendIssue(issueId) {
  return api.post(`/newsletter/issues/${issueId}/send`);
}

/**
 * Newsletter planen
 */
export async function scheduleIssue(issueId, scheduledFor) {
  return api.post(`/newsletter/issues/${issueId}/schedule`, { scheduled_for: scheduledFor });
}

const newsletterService = {
  getNewsletterStats,
  getSubscribers,
  addSubscriber,
  updateSubscriber,
  deleteSubscriber,
  getIssues,
  getIssue,
  createIssue,
  updateIssue,
  deleteIssue,
  sendIssue,
  scheduleIssue
};

export default newsletterService;
